import { Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { RejectClienteDataModal } from '@/erp/clientes/cliente-update-data/shared';
import { calcLineaNameContrato, ContratosCorreccionPara, ROUTER_PATHS, useIsMediaQuery } from '@/shared';
import { useRevisarContrato, useUpdateContrato } from '@/shared/actions/erp';
import { AlertSeverityEnum, Contrato, EstadosActualizacionCompatibilityContratoEnum, EstadosActualizacionContratoEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { useState } from 'react';
import ModalVerHistorialObservaciones from '../ModalVerHistorialObservaciones';

export type ClienteFibraFormTitleProps = {
  contract: Contrato;
  showRejectButton?: boolean;
};

const ClienteFibraFormTitle: React.FC<ClienteFibraFormTitleProps> = ({
  contract,
  showRejectButton = false
}) => {

  const returnUrlClientes = ROUTER_PATHS.clientes.fibraOpticaNav
  const setIsGlobalLoading = useUiStore(s => s.setIsGlobalLoading);
  const setAlert = useUiStore(s => s.setAlert);

  const [openRechazoModal, setOpenRechazoModal] = useState(false)
  const [openVerHistorial, setOpenVerHistorial] = useState(false)

  const clientesFibraOpticaReturnUrl =
    ROUTER_PATHS.clientes.fibraOpticaNav;

  const navigate = useNavigate();
  const isMobile = useIsMediaQuery('sm');



  const updateContrato = useUpdateContrato({
    navigate,
    returnUrl: returnUrlClientes,
    customSuccessMessage: 'Datos de contrato actualizados',
    enableRedirect: true,
  });

  const revisarContrato = useRevisarContrato({})

  const contratoRevisado = async () => {
      
      try {
        const statusUpdateContrato = await updateContrato.mutateAsync({
          id: contract.id_contrato!,
          data: {
            estado_actualizacion: EstadosActualizacionContratoEnum.REVISADO,
            correccion_para:null
          },
        });
        if(statusUpdateContrato.code==200){
          await revisarContrato.mutateAsync(
            contract.preagendamiento_data?.id_preagendamiento!
          )
        }
      } catch (error) {
        console.log(`Error al actualizar el estado de actualización del contrato ${error}`)
        setAlert(
          true,
          `Error al actualizar el estado de actualización del contrato`,
          AlertSeverityEnum.error,
          3000
        );
      }
      
      setIsGlobalLoading(false);
    
  };


  const corregidoPorTecnico = async () => {      
    try {
      const dataToSend : any = {}

      dataToSend.correccion_para = contract?.correccion_para == ContratosCorreccionPara.VENTAS_TECNICO?
        ContratosCorreccionPara.VENTAS
        :null;

      if(dataToSend.correccion_para==null){
        dataToSend.estado_actualizacion = EstadosActualizacionContratoEnum.CORREGIDO
      }

      await updateContrato.mutateAsync({
        id: contract.id_contrato!,
        data: dataToSend,
      });

      // if(statusUpdateContrato.code==200){
      //   await revisarContrato.mutateAsync(
      //     contract.preagendamiento_data?.id_preagendamiento!
      //   )
      // }
    } catch (error) {
      console.log(`Existen problemas al actualizar el estado de actualización del contrato${error}`)
      setAlert(
        true,
        `Existen problemas al actualizar el estado de actualización del contrato.`,
        AlertSeverityEnum.error,
        3000
      );
    }
    
    setIsGlobalLoading(false);
    
  };

  

  return (
    <Grid item xs={12} container>
      <Grid item xs={12} md={9}>
        <Typography variant="h4" pb={isMobile ? 3 : 6}>
          {calcLineaNameContrato(contract) + ' '}

          <span className="cliente__page--title">
            (#{contract?.numero_referencia})
          </span>
        </Typography>
        <Typography>
          <p>Estado de Contrato:</p>
        </Typography>
        <Typography variant="h6" pb={isMobile ? 3 : 6}>
          <span
            style={{color:`${contract?.estado_actualizacion?.toUpperCase() == EstadosActualizacionContratoEnum.REVISADO?"#10B981":"orange"}`}}
          >
            {
              contract?.estado_actualizacion == EstadosActualizacionContratoEnum.REVISADO?
                EstadosActualizacionCompatibilityContratoEnum?.APROBADO
              :contract?.estado_actualizacion == EstadosActualizacionContratoEnum.ACTUALIZADO?
                EstadosActualizacionCompatibilityContratoEnum?.PENDIENTE_REVISION
              :contract?.estado_actualizacion?.toUpperCase()
            }
          </span>
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        md={12}
        container
        justifyContent="flex-end"
        alignItems="flex-start"
      >
        <Button
          onClick={() => navigate(clientesFibraOpticaReturnUrl)}
          variant="outlined"
          sx={{
            py: 1,
            my: 0,
            marginX:1
          }}
          size="small"
        >
          Regresar
        </Button>
        <Button
          onClick={() => contratoRevisado()}
          variant="outlined"
          color='success'
          sx={{
            py: 1,
            my: 0,
            marginX:1
          }}
          size="small"
          disabled={ contract?.estado_actualizacion == EstadosActualizacionContratoEnum.REVISADO?true:false}
        >
          Aprobar
        </Button>
        {
          contract?.correccion_para === ContratosCorreccionPara.VENTAS_TECNICO
          || contract?.correccion_para === ContratosCorreccionPara.TECNICO?
            <Button
              onClick={() => corregidoPorTecnico()}
              variant="outlined"
              color='info'
              sx={{
                py: 1,
                my: 0,
                marginX:1
              }}
              size="small"
              disabled={ 
                contract?.estado_actualizacion == EstadosActualizacionContratoEnum.REVISADO?
                true:false}
            >
              {/* Corregir por Técnico */}
              Corregido por Técnico
            </Button>
          :null
        }
        {
          contract?.observaciones_contrato?.contenido?.length!>0?
            <Button
              onClick={() => setOpenVerHistorial(true)}
              variant="outlined"
              color='primary'
              sx={{
                py: 1,
                my: 0,
                marginX:1
              }}
              size="small"
              disabled={ contract?.estado_actualizacion == EstadosActualizacionContratoEnum.REVISADO?true:false}
            >
              Ver Observaciones
            </Button>
          :null
        }
        {
          showRejectButton?
            <Button
              color='warning'
              onClick={() => setOpenRechazoModal(true)}
              variant="outlined"
              sx={{
                py: 1,
                my: 0,
              }}
              size="small"
              disabled={ contract?.estado_actualizacion == EstadosActualizacionContratoEnum.REVISADO?true:false}
            >
              Solicitar Corrección
            </Button>
          :null
        }
        
        <RejectClienteDataModal
          open={openRechazoModal}
          setOpen={setOpenRechazoModal}
          idIncomingData={contract?.id_contrato!}
          incomingData={contract!}
        />
        <ModalVerHistorialObservaciones
          open={openVerHistorial}
          setOpen={setOpenVerHistorial}
          contract={contract!}
        />
      </Grid>
    </Grid>
  );
};

export default ClienteFibraFormTitle;